import ApplicationStyles from 'app/styles/ApplicationStyles';

import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    container: {
        flex: 1,
        display: 'flex',
        justifyContent:'flex-end',
        flexDirection: 'row'
    },
    button: {
        marginLeft: 8,
    },
}));
export const styles = ({
    ...ApplicationStyles.margins,
    ...ApplicationStyles.flexBox,
	titleBox: {
        ...ApplicationStyles.margins.baseHorizontalMargin,
        ...ApplicationStyles.margins.smallVerticalMargin
    },
    inputSelect:{
    	width: '100%',
    	paddingRight: '2%'
    }
})